var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 16.875H11.375M8.875 16.875L9.1875 14.375H11.0625L11.375 16.875M8.875 16.875H7M11.375 16.875H13.25M3.25 3.125H17C17.3315 3.125 17.6495 3.2567 17.8839 3.49112C18.1183 3.72554 18.25 4.04348 18.25 4.375V13.125C18.25 13.4565 18.1183 13.7745 17.8839 14.0089C17.6495 14.2433 17.3315 14.375 17 14.375H3.25C2.91848 14.375 2.60054 14.2433 2.36612 14.0089C2.1317 13.7745 2 13.4565 2 13.125V4.375C2 4.04348 2.1317 3.72554 2.36612 3.49112C2.60054 3.2567 2.91848 3.125 3.25 3.125Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.f4664083972c9ff9f1ee76753f98d13b.svg";
export { ForwardRef as ReactComponent };